<div class="row">
  <div class="col">
      <div class="blocks m-3 pt-0 px-0">

          <form [formGroup]="formBuilder">

              <!--Scelta tipo-->
              <div class="row pt-4 px-3">
                  <div class="col-12 m-3">
                      <label for="exampleFormControlInput1" class="form-label label-fw">Crea: </label>
                      <div class="form-check form-check-inline mx-3">
                          <input formControlName="type" name="type" class="form-check-input" type="radio"  id="inlineRadio1"
                              value="EVENTO">
                          <label class="form-check-label" for="inlineRadio1">Evento</label>
                      </div>
                      <div class="form-check form-check-inline mx-3">
                          <input formControlName="type" name="type" class="form-check-input" type="radio" id="inlineRadio2"
                              value="PROMOZIONE" checked>
                          <label class="form-check-label" for="inlineRadio2">Promozione</label>
                      </div>
                  </div>
              </div>

              <!--main input-->
              <div class="row px-3">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div class="m-3">
                        <label for="field_index" class="form-label label-fw">Posizione</label>
                        <input formControlName="index" name="index" type="text" class="form-control form-fw " id="field_index" placeholder="Posizione">
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div class="m-3">
                        <label for="field_analyticsCode" class="form-label label-fw">AnalyticsCode</label>
                        <input formControlName="analyticsCode" name="analyticsCode" type="text" class="form-control form-fw " id="field_analyticsCode" placeholder="AnalyticsCode">
                    </div>
                </div>
              </div>
              <div class="row px-3">
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div class="m-3">
                          <label for="field_name" class="form-label label-fw">Nome *</label>
                          <input formControlName="name" name="name" type="text" class="form-control form-fw " id="field_name" placeholder="Name">
                      </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div class="m-3">
                          <label for="field_landingPagePromotion" class="form-label label-fw">URL Landing page</label>
                          <input formControlName="landingPagePromotion" name="landingPagePromotion" type="text" class="form-control form-fw " id="field_landingPagePromotion"
                              placeholder="LandingPage">
                      </div>
                  </div>
              </div>

              <div class="row px-3">
                  <div class="col-12">
                      <div class="m-3">
                          <label for="DescrizionePromo" class="form-label label-fw">Descrizione</label>
                          <ckeditor 
                            #description="ngModel"
                            [(ngModel)]="ckValue" 
                            [ngModelOptions]="{standalone: true}" 
                            name="description" 
                            required [config]="ckeConfig" 
                            (ngModelChange)="detectFormChange()" 
                            debounce="500">
                      </ckeditor>
                      </div>
                  </div>
              </div>


              <hr class="m-3">

              <div class="row px-3">
                <div class="col-12">
                    <div class="m-3">
                        <label for="DescrizionePromo" class="form-label label-fw">Descrizione2</label>
                        <ckeditor 
                            #description2="ngModel"
                            [(ngModel)]="ckValue2" 
                            [ngModelOptions]="{standalone: true}" 
                            name="description2" 
                            required 
                            [config]="ckeConfig" 
                            (ngModelChange)="detectFormChange()" 
                            debounce="500">
                        </ckeditor>
                    </div>
                </div>
            </div>

            <hr class="m-3">

              <!--Validità-->
              <div class="row px-3">
                  <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                      <div class="m-3">
                          <label for="exampleFormControlInput1" class="form-label label-fw">Giorno inizio</label>
                          <input type="date" formControlName="startDay" name="startDay" class="form-control form-fw lh-base" id="exampleFormControlInput1">
                      </div>
                  </div>
                  <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                      <div class="m-3">
                          <label for="exampleFormControlInput1" class="form-label label-fw">Ora</label>
                          <input type="time" formControlName="startTime" name="startTime" class="form-control form-fw lh-base" id="exampleFormControlInput1">
                      </div>
                  </div>
                  <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                      <div class="m-3">
                          <label for="exampleFormControlInput1" class="form-label label-fw">Giorno fine</label>
                          <input type="date" formControlName="expirationDay" name="expirationDay" class="form-control form-fw lh-base" id="exampleFormControlInput1"
                              placeholder="gg/mm/aaaa">
                      </div>
                  </div>
                  <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                      <div class="m-3">
                          <label for="exampleFormControlInput1" class="form-label label-fw">Ora</label>
                          <input type="time" formControlName="expirationTime" name="expirationTime" class="form-control form-fw lh-base" id="exampleFormControlInput1">
                      </div>
                  </div>
              </div>
              <hr class="m-3">
              <!--Switch-->
              <div class="row px-3 my-4">
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div class="form-check form-switch d-flex px-3">
                          <div class="justify-content-start w-100">
                              <label class="form-check-label toggle-text label-fw"
                                  for="flexSwitchCheckChecked">PromotionAppointment</label>
                          </div>
                          <div class="justify-content-end">
                              <label class="switch">
                                  <input  formControlName="promotionAppointment" 
                                          name="promotionAppointment" 
                                          type="checkbox">
                                  <span class="slider round"></span>
                              </label>
                          </div>
                      </div>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div class="form-check form-switch d-flex px-3">
                          <div class="justify-content-start w-100">
                              <label class="form-check-label toggle-text label-fw"
                                  for="flexSwitchCheckChecked">PromotionVisibility</label>
                          </div>
                          <div class="justify-content-end">
                              <label class="switch">
                                  <input  formControlName="promotionVisibility" 
                                          name="promotionVisibility" 
                                          type="checkbox">
                                  <span class="slider round"></span>
                              </label>
                          </div>
                      </div>
                  </div>

              </div>



              <!--Select-->
              <div class="row px-3 my-4">
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div class="mx-3">
                        <label for="field_urlClickAndCollectType" class="form-label label-fw">Url Prenota e ritira
                        </label>
                        <select 
                                (change)="changeUrlClickAndCollectType()"
                                formControlName="urlClickAndCollectType" 
                                name="urlClickAndCollectType"
                                class="form-select select-wh" 
                                id="field_urlClickAndCollectType">
                            <option value="" selected>Nessuna</option>
                            <option *ngFor="let obj of urlClickAndCollectTypeList" value="{{obj.value}}">
                               {{obj.label}}
                            </option>
                        </select>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div class="mx-3">
                          <label for="field_documentId" class="form-label label-fw">Documento</label>
                          <ng-autocomplete #documentIds placeholder="Cerca Documenti"
                          [data]="documentIds_Suggestion" [searchKeyword]="documentIds_Keyword"
                          (selected)='selectEvent__documentIds($event)'
                          (inputChanged)='getList_documentIds($event)'
                          (inputFocused)='onFocused__documentIds($event)'
                          (inputCleared)="searchCleared__documentIds()"
                          [itemTemplate]="itemTemplate_documentIds"
                          [notFoundTemplate]="notFoundTemplate_documentIds" [debounceTime]="600" 
                          [formControl]="initialDocumentValue"
                          [isLoading]="documentIds_isKeywordLoadingResult" [minQueryLength]="2">
                      </ng-autocomplete>
                      <ng-template #itemTemplate_documentIds let-item>
                          <div class="col-12">
                              <div class="mx-3">
                                  <span [innerHTML]="item.name"></span>
                              </div>
                          </div>
                      </ng-template>
                      <ng-template #notFoundTemplate_documentIds let-notFound>
                          {{errorMsg_documentIds}}
                      </ng-template>
                      </div>
                  </div>
              </div>



              <!--Image-->
              <div class="row px-3 my-4 align-items-center">
                  <div class="col m-3">
                      <label for="exampleFormControlInput1" class="form-label label-fw">
                          Immagine
                        </label>
                        <br>
                      <button type="button" class="btn btn-outline-warning btn-outline-fw text my-3" (click)="openLoadImageFromPC()">
                          Carica da PC
                      </button>
                      <button type="button" class="btn btn-outline-warning btn-outline-fw text my-3" (click)="openLoadImageFromDAM()">
                          Carica da  D.A.M.
                      </button>
                      <button type="button" class="btn btn-outline-warning btn-outline-fw text my-3" (click)="deleteImage()">
                          Elimina
                      </button>

                      <div class="thumb-area d-flex justify-content-center my-3">
                          <div class="icona justify-content-center" [hidden]="visibleImageChoice">
                              <i class="fas fa-camera"></i>
                          </div>
                          <img [src]="imageChoice.url" alt="Anteprima" class="img-thumbnail img-thumbnail-dim" [hidden]="!visibleImageChoice">
                      </div>

                      <input type="text" formControlName="iconId" name="iconId" hidden>
                  </div>
              </div>


          </form>




          <!--Buttons-->
          <div class="row">
              <div class="col-12">
                  <div class="my-4 text-center">
                      <button type="button" class="btn btn-fw text me-3"  (click)="clickButtonSave()" [disabled]="!(form.status === 'VALID' && form.touched == true)">Salva modifiche</button>
                      <button type="button" class="btn btn-outline-fw text" (click)="clickButtonCancel()">Annulla</button>
                  </div>
              </div>
          </div>



      </div>
  </div>
</div>